import get from 'lodash/get'
import React from 'react'
import { Query } from 'react-apollo'
import Loader from '../../../common/loader/Loader'
import { HesburgerServicePromptnessTable } from '../../../common/monthlyWeeklyInfo/HesburgerServicePromptnessTable'
import { User } from '../../auth/types'
import withUser from '../../auth/withUser'
import ImageOverlay from '../../weeklyInfo/ImageOverlay/ImageOverlay'
import Images from '../../weeklyInfo/components/Images'
import Links from '../../weeklyInfo/components/Links'
import MonthlyInfoPage from '../MonthlyInfoPage'
import SalesAndHours from '../SalesAndHours'
import css from '../monthlyInfoPage.css'
import { fetchHesburgerEfficiencies } from '../monthlyInfoQueries'
import HesburgerEfficiencyFactorTable from './HesburgerEfficiencyFactorTable'

type HesburgerPageProps = {
  user: User
}

type HesburgerPageState = {
  imageOverlayIsOpen: boolean
  selectedImage?: string
}

@withUser
class HesburgerPage extends React.Component<HesburgerPageProps, HesburgerPageState> {
  state = {
    imageOverlayIsOpen: false,
    selectedImage: undefined,
  }

  selectImage = (imageContent: string) => {
    this.setState({
      selectedImage: imageContent,
      imageOverlayIsOpen: true,
    })
  }

  render() {
    const { user } = this.props
    const { imageOverlayIsOpen, selectedImage } = this.state

    return (
      <MonthlyInfoPage subject='Hesburger'>
        {({ stationId, date, dateFormat, onDateChange, companyId }) => (
          <div className={css.content}>
            <ImageOverlay
              isOpen={imageOverlayIsOpen}
              image={selectedImage}
              onClose={() =>
                this.setState({
                  selectedImage: undefined,
                  imageOverlayIsOpen: false,
                })
              }
            />
            <HesburgerServicePromptnessTable date={date} stationId={stationId} isMonthlyInfo />
            <Query
              query={fetchHesburgerEfficiencies}
              variables={{
                stationId,
                date,
              }}
            >
              {({ data, error, loading, refetch }) => (
                <Loader
                  {...{
                    error,
                    loading,
                  }}
                >
                  <HesburgerEfficiencyFactorTable
                    efficiencyFactors={get(data, 'hesburgerEfficiencyFactor', null)}
                    efficiencyBoundary={get(data, 'hesburgerEfficiencyBoundary', null)}
                    date={date}
                    stationId={stationId}
                    refetch={refetch}
                  />
                </Loader>
              )}
            </Query>
            <SalesAndHours date={date} stationId={stationId} showOnly='Hesburger' />
            <Images
              stationId={stationId}
              selectImage={this.selectImage}
              user={user}
              imageType={'monthlyinfo_hesburger'}
            />
            <Links stationId={stationId} linkType={'monthlyinfo_hesburger'} companyId={companyId} />
          </div>
        )}
      </MonthlyInfoPage>
    )
  }
}

export default HesburgerPage
